import React from 'react';
import FormField from '../FormField';

export default function SaneamentoResiduos() {
  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações sobre a situação atual dos serviços de saneamento e a gestão de resíduos sólidos no município.</p>
      </div>

      <div className="mt-4">
        <FormField
          name="saneamento_residuos_situacao"
          label="Situação atual"
          type="textarea"
          placeholder="Descreva a situação atual dos serviços de água, esgoto, tratamento, drenagem, coleta de resíduos, coleta seletiva, destinação final, cooperativas e participação de catadores"
          helpText="Considere serviços de água, esgoto, tratamento, drenagem, coleta de resíduos, coleta seletiva, destinação final, cooperativas e participação de catadores"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="saneamento_residuos_indicadores"
          label="Principais indicadores"
          type="textarea"
          placeholder="Informe os principais indicadores encontrados, como cobertura de água e esgoto, volume tratado, áreas alagáveis, cobertura da coleta, toneladas coletadas, taxa de reciclagem e número de catadores, sempre com ano e unidade de referência"
          helpText="Cobertura de água e esgoto, volume tratado, áreas alagáveis, cobertura da coleta, toneladas coletadas, taxa de reciclagem e número de catadores, sempre com ano e unidade de referência"
          rows={5}
          className="[&_.input]:min-h-[10rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="saneamento_residuos_problemas"
          label="Principais problemas identificados"
          type="textarea"
          placeholder="Descreva os principais problemas identificados, considerando ausência de rede, lançamentos irregulares, enchentes, manutenção, lixões, baixa reciclagem e descarte irregular"
          helpText="Considere ausência de rede, lançamentos irregulares, enchentes, manutenção, lixões, baixa reciclagem e descarte irregular"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <div className="mt-4">
        <FormField
          name="saneamento_residuos_demandas"
          label="Demandas prioritárias identificadas"
          type="textarea"
          placeholder="Descreva as demandas prioritárias identificadas, considerando ampliação de redes, ETEs, drenagem, investimentos, centrais de triagem, coleta seletiva, compostagem e capacitação"
          helpText="Considere ampliação de redes, ETEs, drenagem, investimentos, centrais de triagem, coleta seletiva, compostagem e capacitação"
          rows={4}
          className="[&_.input]:min-h-[8rem]"
        />
      </div>

      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao3"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />

        <FormField
          name="links_acesso_secao3"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
